import { useState } from "react";
import styles from "./Button.module.scss";

export const Button = ({
  variant = "primary", // primary, secondary, outline, ghost
  size = "medium", // small, medium, large
  leftIcon,
  rightIcon,
  children,
  fullWidth = false,
  disabled = false,
  onClick,
  type = "button", // button, submit, reset
  className = "",
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const leftHoverIcon = props["data-left-icon-hover"];
  const rightHoverIcon = props["data-right-icon-hover"];

  const getIcon = (icon, hoverIcon) => {
    if (!icon) return null;
    if (isHovered && hoverIcon && !disabled) {
      if (icon.type === "img") {
        return (
          <img
            src={hoverIcon}
            alt={icon.props.alt || "icon"}
            className={icon.props.className}
            width={icon.props.width}
            height={icon.props.height}
          />
        );
      }
    }
    return icon;
  };

  const buttonClasses = [
    styles.button,
    styles[`button--${variant}`],
    styles[`button--${size}`],
    fullWidth ? styles["button--full-width"] : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      type={type}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      {leftIcon && (
        <span className={`${styles.icon} ${styles["icon--left"]}`}>
          {getIcon(leftIcon, leftHoverIcon)}
        </span>
      )}
      {children && <span className={styles.text}>{children}</span>}
      {rightIcon && (
        <span className={`${styles.icon} ${styles["icon--right"]}`}>
          {getIcon(rightIcon, rightHoverIcon)}
        </span>
      )}
    </button>
  );
};
